class HeaderSearch {


  constructor() {



  }


}


class Custom {
  constructor() {

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      this.init()
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.init()
      })
    }
  }

  init() {

    // new HeaderSearch();

  }
}

new Custom();

